<template>
  <v-content>
    <div id="core-view">
      <v-fade-transition mode="out-in">
        <router-view/>
      </v-fade-transition>
    </div>
    <core-footer v-if="$route.name !== 'Maps'"/>
  </v-content>
</template>

<script>
export default {
  name: "core-view",

  components: {
    Footer: () => import("@/components/core/Footer")
  },

  metaInfo() {
    return {
      title: "Dashboard - Disc Test"
    };
  }
};
</script>

<style>
#core-view {
  padding-bottom: 100px;
}
</style>
